module.exports = __webpack_public_path__ + "img/chinesecompany120.e40ed8a5.png";